const handleNav = (data) => {
  if (
    data === "SUPER_ADMIN" ||
    data === "MAKER" ||
    data === "CHECKER" ||
    data === "ADMIN"
  ) {
    window.location.href = "/admin_dashboard";
  } else if (data === "ANALYST") {
    window.location.href = "/analyst_dashboard";
  } else if (data === "TRADER") {
    window.location.href = "/trader_dashboard";
  } else if (data === "BANKING") {
    window.location.href = "/banking";
  } else if (data === "COMPANY_ADMIN") {
    window.location.href = "/admin_company_dashboard";
  } else if (data === "CONSUMER" || data === "GENERATOR") {
    window.location.href = "/dashboard";
  }
};

export default handleNav;
